import { render } from "./GroupSurveyReport.vue?vue&type=template&id=2182aefe"
import script from "./GroupSurveyReport.vue?vue&type=script&lang=js"
export * from "./GroupSurveyReport.vue?vue&type=script&lang=js"

import "./GroupSurveyReport.vue?vue&type=style&index=0&id=2182aefe&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__